import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import { Link, useI18next } from 'gatsby-plugin-react-i18next'
import styled from 'styled-components'

const StyledText = styled.p`
  color: #ccc;
  font-family: elsevier-sans;
  font-size: 20px;
  line-height: 28px;
  position: relative;
  width: fit-content;
  margin-bottom: 16px !important;
  :after {
    border:0px;
    background-color: transparent;
    transition: background-color 0.3s, bottom 0.2s;
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    left: 1px;
    height: 2px;
    background-color: transparent;
    pointer-events: none;
  }
  &:hover {
    :after {
      background-color: #ff6c00 !important;
    }
  }
`

const LanguageSwitcher = () => {
  const { languages, originalPath, t } = useI18next();

  return (
    <>
      {languages.map(lng => (
        <StyledText key={uuidv4()}>
          <Link to={originalPath} language={lng}>
            {t(lng)}
          </Link>
        </StyledText>
        ))}
    </>
  );
};

export default LanguageSwitcher;
